import ModelPredictions from './ModelPredictions'

export default ModelPredictions
